<ion-button
  fill="outline"
  shape="round"
  [attr.aria-label]="'general.edit' | translate"
  (click)="openEditModal()"
>
  <ion-icon
    slot="icon-only"
    aria-hidden="true"
    src="../assets/material-symbols/edit_24dp.svg"
  ></ion-icon>
</ion-button>
